module.exports = __webpack_public_path__ + "static/media/HCMM210.edaf87f5.jpg";